import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import React, { useState } from 'react';
import { Modal, Platform } from 'react-native';
import styled from 'styled-components/native';
import { SccPressable } from '@/components/SccPressable';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import PanoramaCanvas from './PanoramaCanvas';
/**
 * 로드뷰(네이버 파노라마) 미리보기 + 풀스크린.
 * - 미리보기: 고정 높이 박스에 비조작 파노라마 + 위 레이어 탭 → 풀스크린 오픈
 * - 풀스크린: RN Modal로 전체화면 조작 가능 파노라마 + 닫기 버튼
 * 내부 PanoramaCanvas만 플랫폼 분기(.web.tsx/.tsx)되어 웹/네이티브 동일 동작.
 */
export default function RoadView({ position, name }) {
    const [isFullScreen, setIsFullScreen] = useState(false);
    // Modal slide 애니메이션이 끝난 뒤(컨테이너가 실제 크기를 가진 뒤) 파노라마 WebView를
    // 마운트한다. 애니메이션 도중 마운트하면 0 크기로 초기화돼 빈 화면이 된다.
    const [isModalShown, setIsModalShown] = useState(false);
    // 핀이 입구를 가릴 때 끌 수 있다.
    const [showPin, setShowPin] = useState(true);
    return (_jsxs(_Fragment, { children: [_jsxs(PreviewContainer, { children: [_jsx(Label, { children: "\uB85C\uB4DC\uBDF0" }), _jsxs(PreviewBox, { children: [!isFullScreen && (_jsx(PanoramaCanvas, { position: position, label: name, showPin: false, interactive: false, style: { width: '100%', height: '100%' } })), _jsx(PreviewOverlay, { elementName: "pdp_roadview_preview", onPress: () => setIsFullScreen(true), children: _jsx(ExpandHint, { children: "\uD0ED\uD558\uC5EC \uC804\uCCB4\uD654\uBA74" }) })] })] }), _jsx(Modal, { visible: isFullScreen, animationType: "slide", supportedOrientations: ['portrait', 'landscape'], onShow: () => setIsModalShown(true), onRequestClose: () => setIsFullScreen(false), children: _jsxs(FullScreenContainer, { children: [isModalShown && (_jsx(PanoramaCanvas, { position: position, label: name, showPin: showPin, interactive: true, style: { flex: 1 } })), _jsxs(TopRightBar, { children: [_jsx(PinToggleButton, { elementName: "pdp_roadview_toggle_pin", logParams: { showPin: !showPin }, onPress: () => setShowPin(prev => !prev), children: _jsx(PinToggleText, { children: showPin ? '핀 가리기' : '핀 보기' }) }), _jsx(CloseButton, { elementName: "pdp_roadview_close", onPress: () => {
                                        setIsModalShown(false);
                                        setIsFullScreen(false);
                                    }, children: _jsx(CloseText, { children: "\uB2EB\uAE30" }) })] })] }) })] }));
}
const PreviewContainer = styled.View `
  padding: 16px;
  gap: 8px;
`;
const Label = styled.Text `
  font-size: 16px;
  font-family: ${font.pretendardBold};
  color: ${color.black};
`;
const PreviewBox = styled.View `
  width: 100%;
  height: 160px;
  border-radius: 12px;
  overflow: hidden;
  background-color: ${color.gray10};
`;
const PreviewOverlay = styled(SccPressable) `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 12px;
`;
const ExpandHint = styled.Text `
  font-size: 12px;
  font-family: ${font.pretendardMedium};
  color: ${color.white};
  background-color: rgba(0, 0, 0, 0.5);
  padding: 4px 10px;
  border-radius: 12px;
  overflow: hidden;
`;
const FullScreenContainer = styled.View `
  flex: 1;
  background-color: ${color.black};
`;
// 우상단에 핀 가리기 + 닫기 버튼을 가로로 나란히. 좌측 zoom 컨트롤과 겹치지 않는다.
const TopRightBar = styled.View `
  position: absolute;
  top: ${Platform.OS === 'web' ? '16px' : '48px'};
  right: 16px;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
const PillButton = styled(SccTouchableOpacity) `
  background-color: rgba(0, 0, 0, 0.6);
  padding: 8px 16px;
  border-radius: 20px;
`;
const CloseButton = styled(PillButton) ``;
const CloseText = styled.Text `
  font-size: 14px;
  font-family: ${font.pretendardBold};
  color: ${color.white};
`;
const PinToggleButton = styled(PillButton) ``;
const PinToggleText = styled.Text `
  font-size: 14px;
  font-family: ${font.pretendardBold};
  color: ${color.white};
`;
